import React, { FunctionComponent } from 'react';
import { Grid, Typography } from '@mui/material';
import ReviewsTable from './ReviewsTable/ReviewsTable';
import useStyles from './ReviewsDashboard.styles';

const ReviewsDashboard: FunctionComponent = () => {
  const classes = useStyles();
  const testid = 'users-table';

  return (
    <Grid container spacing={4}>
      <Grid size={{ xs:12 }}>
        <Typography
          variant="h1"
          classes={{ root: classes.title }}
          data-testid={`${testid}__title`}
        >
          HealthySteps ROI Calculations for Review
        </Typography>
      </Grid>
      <Grid size={{ xs:12 }}>
        <ReviewsTable />
      </Grid>
    </Grid>
  );
};

export default ReviewsDashboard;